import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { threadListApiV1CollaborationAppThreadGetQueryKey } from '../gen/base'

export const useInvalidateThreadListQuery = () => {
    const queryClient = useQueryClient()

    return useCallback(() => {
        queryClient.invalidateQueries({
            predicate: (query) =>
                query.queryKey.some(
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    //@ts-expect-error
                    (key) => key?.url === threadListApiV1CollaborationAppThreadGetQueryKey()[0].url,
                ),
        })
    }, [queryClient])
}
